/*
 * ===============================================================================================================
 *                                Copyright 2021, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const LABELS = {
  CANCEL: 'Cancel',
  SAVE: 'Save',
  CREATE_USER_GROUP: 'Add User Group',
  USER_GROUP_NAME: 'User Group Name',
  USER_GROUP_NAME_REQUIRED: 'User Group Name is required',
  USER_GROUP_NAME_MAX_LENGTH: 'User Group Name should be less than 100 characters',
}